import { PROPERTY_DATA_KV_MAP } from '@/constants';
import {
  applyFilterChanges,
  getFilterChangesForDropdownEnabledForSingleCheckbox,
  getFilterChangesForMutuallyExclusiveCheckboxes,
} from './utils';

const mutuallyExclusiveComplaintsOptions = new Set([
  PROPERTY_DATA_KV_MAP.complaints.hasComplaints,
  PROPERTY_DATA_KV_MAP.complaints.hasNoComplaints,
]);

export function applyComplaintsSingleParamChange(
  mapFilterParams,
  selectedGroupName,
  selectedOption,
  selectedValue
) {
  const filterChanges = [
    {
      groupName: selectedGroupName,
      option: selectedOption,
      value: selectedValue,
    },
  ];

  filterChanges.push(
    ...getFilterChangesForMutuallyExclusiveCheckboxes(
      selectedGroupName,
      selectedOption,
      selectedValue,
      mutuallyExclusiveComplaintsOptions
    )
  );

  filterChanges.push(
    ...getFilterChangesForDropdownEnabledForSingleCheckbox(
      selectedGroupName,
      selectedOption,
      selectedValue,
      mutuallyExclusiveComplaintsOptions,
      PROPERTY_DATA_KV_MAP.complaints.complaintTypes,
      PROPERTY_DATA_KV_MAP.complaints.hasComplaints
    )
  );

  return applyFilterChanges(mapFilterParams, filterChanges);
}
